module.exports = __webpack_public_path__ + "img/6.c60b8a68.jpg";